<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">店员晋升</div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div>
              <el-select v-model="query.auditStatus" placeholder="全部状态" filterable @change="selectChange">
                <el-option
                  v-for="item in option1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="applyPromotion" v-perm="{key:'attendancePunch', value: 'attendancePunch:elevate'}">申请</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="elevatePositionName" label="晋升职位" width="auto"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
              <el-table-column prop="createTime" width="auto" label="申请时间">
                <template slot-scope="scope">
                  <span>{{formatDate(scope.row.createTime)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" @click="details(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail ref="detailForm" @change="auditBack"></detail>
    <add ref="addForm" @change="auditBack"></add>
  </div>  
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "./detail.vue";
import add from "./add.vue";
export default {
  data() {
    return {
      url: this.$url.staffPositionElevate.list,
      urlCount: this.$url.staffPositionElevate.count,
      query: {
        dataMonth: "",
        auditStatus: "",
        subsidyType: "",
        start: 1,
        size: 20
      },
      option1: [{
          label: "全部状态",
          value: ""
        },
        {
          label: "待审核",
          value: "wait"
        },
        {
          label: "处理中",
          value: "processing"
        },
        {
          label: "通过",
          value: "pass"
        },
        {
          label: "拒绝",
          value: "refuse"
        },
        {
          label: "取消",
          value: "cancel"
        }
      ],
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: {detail,add},
  computed: {},

  created() {
    this.query.dataMonth = this.formatMonth(new Date())
    this.totalCounts();
  },

  methods: {
    details (row) {
      this.$refs["detailForm"].$emit("set", row.id);
    },
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    auditBack () {
      this.totalCounts();
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.urlCount, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    applyPromotion () {
      this.$refs["addForm"].$emit("set", true);
    },
    getAllSubsidyType() {
      this.$api.get(this.$url.subsidyApply.getAllSubsidyType).then(res => {
        console.log(res)
        this.option2 = res;
      })
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
.cookAllowance {
  height: 100%;
  .mains-content {
    margin: 0 16px;
    height: calc(100vh - 127px);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    .comingSoon-img {
      width: 170px;
      height: 170px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .comingSoon-title {
      text-align: center;
      margin-top: 20px;
      color: #A7A7A7;
      font-size: 16px;
    }
  }
}
</style>